import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserNameFromReducer, getLoaderState } from "Store/reducers/Auth/AuthSlice";
import { Loader } from "@/Components/Loader";

function PublicRoute(props) {
  const { token } = props;
  const username = useSelector(getUserNameFromReducer);
  const isLoading = useSelector(getLoaderState);
  
  // If user is authenticated
  if (token) {
    // Show loading while username is being fetched
    if (!username && isLoading) {
      return (
        <div className="div-center h-screen flex flex-col">
          <Loader />
          <p className="mt-2">Loading your profile...</p>
        </div>
      );
    }
    
    // If username is available, redirect to user's profile
    if (username) {
      return <Navigate to={`/${username}`} replace />;
    }
    
    // Fallback: if token exists but no username and not loading, redirect to login
    return <Navigate to="/login" replace />;
  }
  
  // Not authenticated, show the requested element
  return props?.element;
}

export default PublicRoute;
